import React, {PureComponent} from "react";
import $ from "jquery";
import {formatDate, formatTime} from "../functions/utils";
import {Modal} from "react-responsive-modal";
import {
    closeSocket,
    connectSocket,
    subscribeClock,
    subscribeDashToServer,
    subscribeToDriverChangeInfo
} from "../functions/api";

import {withTranslation} from "react-i18next";
import {withCookies} from "react-cookie";

const serverIP = process.env.REACT_APP_SERVER_IP;

const backendPort = process.env.REACT_APP_BACKEND_PORT;

class SeatTimeMonitor extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            tableRows: [],
            drivers: [],
            orderSwitch: "asc",
            orderType: "nr",
            searchVehicle: "",
            show: false,
            modalRows: null,
            now: new Date().getTime(),
        };

        this.makeRows = this.makeRows.bind(this);
        this.getData = this.getData.bind(this);
        this.getSessionDetails = this.getSessionDetails.bind(this);

        this.handleClocks = this.handleClocks.bind(this);
        this.handleChangeVehicleSearch = this.handleChangeVehicleSearch.bind(this);
        this.handleShowModal = this.handleShowModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);

        this.reorderCarList = this.reorderCarList.bind(this);
        this.handleChangeSort = this.handleChangeSort.bind(this);
        this.compareLivery = this.compareLivery.bind(this);
        this.compareState = this.compareState.bind(this);
        this.compareStintTime = this.compareStintTime.bind(this);
        this.compareLastDriverChange = this.compareLastDriverChange.bind(this);
    }

    /* LIFE CYCLE */
    componentDidMount() {
        $(".loading").fadeIn();
        this.getSessionDetails((msg) => {
            connectSocket(this.props.cookies.get("authToken"), null, this.props.match.params.sessionID, this.props.match.params.eventID, "SEAT TIME", (msg) => {
                subscribeClock((obj) => {
                    this.setState({
                        now: obj.tim,
                    });
                });
                this.getData();
                subscribeDashToServer(this.props.match.params.eventID, this.props.match.params.sessionID, () => {
                    console.log("[SEAT TIME] DEDICATED STREAM SUBSCRIBED");
                });
                subscribeToDriverChangeInfo(this.props.match.params.eventID, false, (err, driverInfo) => {
                    this.getData();
                });
            });
        });
    }

    componentWillUnmount() {
        subscribeDashToServer(this.props.match.params.eventID, this.props.match.params.sessionID, () => {
            console.log("[SEAT TIME] DEDICATED STREAM UNSUBSCRIBED");
        });
        subscribeToDriverChangeInfo(this.props.match.params.eventID, true, null);
        closeSocket();
        clearInterval(this.generalClocks);
        subscribeClock(null);
    }

    /* GET DATA */
    getSessionDetails(cb) {
        const helper = this;
        $.ajax({
            type: "POST",
            url: serverIP + ":" + backendPort + "/dashboard/getSessionDetails",
            dataType: "json",
            headers: {
                "authorization": helper.props.cookies.get("authToken")
            },
            data: {
                sessionID: parseInt(helper.props.match.params.sessionID),
            },
            success: function (data) {
                helper.setState({
                    timezone: data.timezone,
                    startTimestamp: data.start_timestamp,
                    sessionStatus: data.session_status,
                }, () => {
                    cb("done");
                    console.log("[SEAT TIME] COMPLETE getSessionDetails");
                });
            },
            error: function (err) {
                if (err) {
                    console.error("Error:", err);
                }
            }
        });
    }

    getData() {
        const helper = this;
        $.ajax({
            type: "POST",
            url: serverIP + ":" + backendPort + "/dashboard/getDriversSeatTime",
            dataType: "json",
            headers: {
                "authorization": helper.props.cookies.get("authToken")
            },
            data: {
                eventID: parseInt(helper.props.match.params.eventID),
                sessionID: parseInt(helper.props.match.params.sessionID),
            },
            success: function (data) {
                helper.setState({
                    drivers: data,
                }, () => {
                    helper.makeRows();
                    helper.handleClocks();
                });
            },
            error: function (err) {
                if (err) {
                    console.error("Error:", err);
                }
                $(".loading").fadeOut();
            }
        });
    }

    /* HANDLERS */
    handleClocks() {
        clearInterval(this.generalClocks);
        let temp = this.state.drivers.slice();

        this.generalClocks = setInterval(() => {

            for (let i = 0; i < temp.length; i++) {
                if (this.state.startTimestamp > 0 && this.state.sessionStatus === "2") {
                    if (temp[i].is_driving === 1) {
                        const now = this.state.now;
                        const currentShift = Math.abs(temp[i].last_timestamp - now);
                        temp[i].real_time_stint = temp[i].stint_time + currentShift;
                    }
                } else {
                    temp[i].real_time_stint = 0;
                }
            }

            this.setState({
                drivers: temp,
            }, () => {
                this.makeRows();
                $(".loading").fadeOut();
            });
        }, 1000);
    }

    handleChangeVehicleSearch(e) {
        e.preventDefault();
        if (!isNaN(e.target.value)) {
            let number = e.target.value;
            this.setState({
                searchVehicle: number,
            }, () => {
                this.makeRows();
            });
        }
    }

    handleShowModal(driverID) {
        const helper = this;
        $.ajax({
            type: "POST",
            url: serverIP + ":" + backendPort + "/dashboard/getDriverStintHistory",
            dataType: "json",
            headers: {
                "authorization": helper.props.cookies.get("authToken")
            },
            data: {
                eventID: parseInt(helper.props.match.params.eventID),
                sessionID: parseInt(helper.props.match.params.sessionID),
                driverID: driverID,
            },
            success: function (data) {
                let modalRows = [];
                if (data.length > 0) {
                    for (let i = 0; i < data.length; i++) {
                        modalRows.push(
                            <tr key={"modal_seat_time_" + i} className={"onHover App_white_text w3-animate-fading"} style={{textAlign: "center", fontSize: 20, color: "#000000"}}>
                                <td style={{color: data[i].action === "ENTER" ? "#00a72d" : "#c81400", fontSize: 25}}>{data[i].action === "ENTER" ? (<i className="fas fa-long-arrow-alt-right"/>) : (<i className="fas fa-long-arrow-alt-left"/>)}</td>
                                <td>{formatDate(data[i].driver_change_timestamp, helper.state.timezone)}</td>
                                <td>{data[i].lap_number}</td>
                                <td>
                                    {data[i].other_driver !== null ? (
                                        <>
                                            <span style={{color: data[i].action === "OUT" ? "#00a72d" : "#c81400", fontSize: 25, verticalAlign: "middle"}}>{data[i].action === "OUT" ? (<i className="fas fa-long-arrow-alt-right"/>) : (<i className="fas fa-long-arrow-alt-left"/>)}</span>
                                            <span>{data[i].other_driver}</span>
                                        </>
                                    ) : (
                                        <>{helper.props.t("firstDriver")}</>
                                    )}
                                </td>
                            </tr>
                        );
                    }
                } else {
                    modalRows.push(
                        <tr key={"modal_seat_time_no_results"}>
                            <td className={"App_title"} colSpan={4} style={{textAlign: "center"}}>{helper.props.t("noResults")}</td>
                        </tr>
                    );
                }
                helper.setState({
                    show: true,
                    modalRows: modalRows,
                });
            },
            error: function (err) {
                if (err) {
                    console.error("Error:", err);
                }
                $(".loading").fadeOut();
            }
        });
    }

    handleCloseModal() {
        this.setState({
            show: false,
            modalRows: null,
        });
    }

    /* SORTING METHODS */
    handleChangeSort(e) {
        this.setState({
            orderType: e.target.id,
            orderSwitch: this.state.orderSwitch === "asc" ? "desc" : "asc",
        }, () => {
            this.reorderCarList();
        });
    }

    reorderCarList() {
        switch (this.state.orderType) {
            case "nr": {
                this.state.drivers.sort(this.compareLivery);
                break;
            }
            case "state": {
                this.state.drivers.sort(this.compareState);
                break;
            }
            case "time": {
                this.state.drivers.sort(this.compareStintTime);
                break;
            }
            case "lastDriverChange": {
                this.state.drivers.sort(this.compareLastDriverChange);
                break;
            }

            default: {
                break;
            }
        }

        this.makeRows();
    }

    compareLivery(a, b) {
        if (this.state.orderSwitch === "asc") {
            if (a.livery_number > b.livery_number) {
                return -1;
            } else if (a.livery_number < b.livery_number) {
                return 1;
            }
        } else {
            if (a.livery_number < b.livery_number) {
                return -1;
            } else if (a.livery_number > b.livery_number) {
                return 1;
            }
        }
    }

    compareState(a, b) {
        if (this.state.orderSwitch === "asc") {
            if (a.is_driving > b.is_driving) {
                return -1;
            } else if (a.is_driving < b.is_driving) {
                return 1;
            }
        } else {
            if (a.is_driving < b.is_driving) {
                return -1;
            } else if (a.is_driving > b.is_driving) {
                return 1;
            }
        }

    }

    compareStintTime(a, b) {
        if (this.state.orderSwitch === "asc") {
            if ((a.is_driving === 1 ? a.real_time_stint : a.stint_time) > (b.is_driving === 1 ? b.real_time_stint : b.stint_time)) {
                return -1;
            } else if ((a.is_driving === 1 ? a.real_time_stint : a.stint_time) < (b.is_driving === 1 ? b.real_time_stint : b.stint_time)) {
                return 1;
            }
        } else {
            if ((a.is_driving === 1 ? a.real_time_stint : a.stint_time) < (b.is_driving === 1 ? b.real_time_stint : b.stint_time)) {
                return -1;
            } else if ((a.is_driving === 1 ? a.real_time_stint : a.stint_time) > (b.is_driving === 1 ? b.real_time_stint : b.stint_time)) {
                return 1;
            }
        }

    }

    compareLastDriverChange(a, b) {
        if (this.state.orderSwitch === "asc") {
            if (a.last_timestamp > b.last_timestamp) {
                return -1;
            } else if (a.last_timestamp < b.last_timestamp) {
                return 1;
            }
        } else {
            if (a.last_timestamp < b.last_timestamp) {
                return -1;
            } else if (a.last_timestamp > b.last_timestamp) {
                return 1;
            }
        }

    }

    /* RENDER */
    makeRows() {
        let rows = [];
        for (let i = 0; i < this.state.drivers.length; i++) {

            if (!isNaN(parseInt(this.state.searchVehicle))) {
                if (("" + this.state.drivers[i].livery_number).indexOf(this.state.searchVehicle) === -1) {
                    continue;
                }
            }

            rows.push(
                <tr key={"seat_time_" + i} className={"onHover App_white_text w3-animate-fading"} style={{textAlign: "center", fontSize: 22}}>
                    <td>
                        <button
                            type={"button"}
                            className={"btn btn-primary btn-block button"}
                            style={{height: "100%"}}
                            onClick={() => {
                                this.handleShowModal(this.state.drivers[i].id);
                            }}
                        >
                            <i className={"fas fa-clipboard-list App_buttonContainer_icons"}/>
                        </button>
                    </td>
                    <td>{this.state.drivers[i].name}</td>
                    <td>#{this.state.drivers[i].livery_number + "  " + this.state.drivers[i].team_name}</td>
                    <td className={"toolTipStyle"}
                        style={{
                            color: this.state.drivers[i].is_driving === 1 ? "#396cff" : "#ff4730",
                        }}
                    >{this.state.drivers[i].is_driving === 1 ? this.props.t("driving").toUpperCase() : this.props.t("onHold").toUpperCase()}</td>
                    <td className={"App_textLaptime"} style={{fontSize: 24}}>{this.state.drivers[i].is_driving === 1 ? (
                        formatTime(this.state.drivers[i].real_time_stint).slice(0, -4)
                    ) : (
                        formatTime(this.state.drivers[i].stint_time).slice(0, -4)
                    )}</td>
                    <td>{formatDate(this.state.drivers[i].last_timestamp, this.state.timezone)}</td>
                </tr>
            );
        }

        this.setState({
            tableRows: rows,
        });
    }

    render() {
        return (
            <>
                <div className="loading">
                    <div className={"loading-text hidden-sm hidden-xs"}>{this.props.t("processing")}</div>
                </div>
                <div className={"App_lapTableContainerStyle table-scroll-parent"} style={{height: "94vh"}}>
                    <div className={"table-scroll-child"}>
                        <table className={"table table-hover"}>
                            <thead>
                            <tr>
                                <th colSpan={2}/>
                                <th style={{textAlign: "center"}}>
                                    <input
                                        className={"form-control App_black_text"}
                                        style={{border: "2px solid #ed2126", height: 40, width: "50%", display: "inline"}}
                                        value={this.state.searchVehicle}
                                        placeholder={"000"}
                                        type={"text"}
                                        onChange={this.handleChangeVehicleSearch}
                                    />
                                </th>
                                <th className={"App_header"} colSpan={5}/>
                            </tr>
                            <tr style={{whiteSpace: "nowrap"}}>
                                <th style={{width: "4%"}}/>
                                <th className={"App_header"} style={{width: "10%"}}>{this.props.t("driver").toUpperCase()}</th>
                                <th id={"nr"} className={"App_header"} style={{cursor: "pointer", width: "15%"}} onClick={this.handleChangeSort}><i className="fas fa-arrows-alt-v"/> {this.props.t("team").toUpperCase()}</th>
                                <th id={"state"} className={"App_header"} style={{cursor: "pointer"}} onClick={this.handleChangeSort}><i className="fas fa-arrows-alt-v"/> {this.props.t("state").toUpperCase()}</th>
                                <th id={"time"} className={"App_header"} style={{cursor: "pointer"}} onClick={this.handleChangeSort}><i className="fas fa-arrows-alt-v"/> {this.props.t("time").toUpperCase()}</th>
                                <th id={"lastDriverChange"} className={"App_header"} style={{cursor: "pointer"}} onClick={this.handleChangeSort}><i className="fas fa-arrows-alt-v"/> {this.props.t("lastDriverChange").toUpperCase()}</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.tableRows}
                            </tbody>
                        </table>
                    </div>
                </div>
                <Modal open={this.state.show}
                       onClose={this.handleCloseModal}
                       center={false}
                       classNames={{modal: "big-modal"}}
                       showCloseIcon={false}
                >
                    <div className={"modal-header"}>
                        <div className={"modal-title"}>
                            <b className={"App_header"} style={{color: "#000000"}}>{this.props.t("shiftHistory")}</b>
                        </div>
                    </div>
                    <div className={"modal-body"}>
                        {this.state.modalRows === null ? (
                            <div style={{width: "100%"}}>
                                <div className={"loader"} style={{margin: "0 auto", marginTop: "15%", marginBottom: "15%"}}/>
                            </div>
                        ) : (
                            <div className={"table-scroll-parent"} style={{height: "70vh"}}>
                                <table className={"table table-hover table-condensedable-scroll-child"}>
                                    <thead>
                                    <tr>
                                        <th className={"App_header"} style={{color: "#000000"}}>{this.props.t("action").toUpperCase()}</th>
                                        <th className={"App_header"} style={{color: "#000000"}}>{this.props.t("time").toUpperCase()}</th>
                                        <th className={"App_header"} style={{color: "#000000"}}>{this.props.t("lap").toUpperCase()}</th>
                                        <th className={"App_header"} style={{color: "#000000"}}>{this.props.t("otherDriver").toUpperCase()}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.modalRows}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                    <div className={"modal-footer"}>
                        <button
                            onClick={this.handleCloseModal}
                            className={"btn App_header button"}
                            style={{background: "#ff0003", color: "#FFFFFF"}}
                        >{this.props.t("close")}
                        </button>
                    </div>
                </Modal>
            </>
        );
    }
}

export default withTranslation("translations")(withCookies(SeatTimeMonitor));